import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import i18n from 'cityads-v3/i18n';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import NumberFormat, { FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat';
import LinkToPayments from 'cityads-v3/containers/webmaster/payments/LinkToPayments';

import classes from './Profile.scss';

@connect(
  state => ({
    user: state.auth.user,
    balance: state.auth.balance,
    needDocumentForPayment: state.header.needDocumentForPayment,
    promo: state.auth.balance.promo || [],
  })
)
@withTranslation(['Payments', 'main'], { i18n, wait: false })
export class Credits extends Component {

  render() {
    const { t, balance, promo, forwardedRef, onClose } = this.props;

    return (
      <Card
        classes={{root: classes.pageContainer}}
        ref={forwardedRef}
      >
        <div className={classes.credits}>
          <div className={classes.totals}>
            <div>{t('balance.holdAdvertiser')}</div>
            <NumberFormat
              number={balance.hold_advertiser}
              format={FORMAT_CURRENCY}
              currency={balance.currency}
            />
          </div>
          <div className={classes.totals}>
            <div>{t('balance.available')}</div>
            <NumberFormat
              number={balance.available}
              format={FORMAT_CURRENCY}
              currency={balance.currency}
            />
          </div>
          <div className={classes.totals}>
            <div>{t('balance.onOutput')}</div>
            <NumberFormat
              number={balance.on_output}
              format={FORMAT_CURRENCY}
              currency={balance.currency}
            />
          </div>
          {this.props.needDocumentForPayment ? (
            <div className={classes.totals}>
              <Trans t={t} i18nKey={'balance.needDocumentForPayment'} parent="div">
                A <LinkToPayments>document is required</LinkToPayments> to calculate payment!
              </Trans>
            </div>
          ) : false}

          {promo.map(item => (
            <div className={classes.totals} key={item.name}>{item.hint}</div>
          ))}

        </div>

        <div className={classes.cardActions}>
          <Button
            component={Link}
            to="/publisher/profile/credits/currencies"
            onClick={onClose}
          >
            {t('main:more_info')}
          </Button>

          <Button
            color="primary"
            component={LinkToPayments}
            variant="contained"
            onClick={onClose}
          >
            {t('title')}
          </Button>
        </div>
      </Card>
    );
  }

}

export default forwardRef((props, ref) => <Credits {...props} forwardedRef={ref} />)
